import React, { useState } from "react";
import { connect } from 'react-redux';
import { Field, FieldArray, reduxForm, stopSubmit, formValueSelector } from "redux-form";
import {
  Form,
  FormGroup,
  Label,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";

import TextInput from "../../system/fields/TextInput";
import SelectDropdown from "../../system/fields/SelectDropdown";
import FileUpload from "../../system/fields/FileUpload";
import StarRating from "../../system/fields/StarRating";
import Switch from '../../system/fields/Switch';

import * as validations from "../../system/utils/Validation";
import Wysiwyg from "../../system/fields/Wysiwyg";

import ReviewsTable from "./components/ReviewsTable";
import Activites from "./components/Activites";
import Faq from "./components/Faq";

let EditForm = (props, { fields }) => {
  const { handleSubmit, mode, featured, initialValues } = props;
  const {name, order, slug} = initialValues;
  const [activeTab, setActiveTab] = useState(1);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  }

  return (
    <section className="edit-form">
      <Form onSubmit={handleSubmit}>

         <Nav tabs>
            <NavItem>
              <NavLink
                className={activeTab === 1 ? "active" : ""}
                onClick={() => {
                  toggleTab(1);
                }}
              >
                Details
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === 2 ? "active" : ""}
                onClick={() => {
                  toggleTab(2);
                }}
              >
                Reviews
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === 3 ? "active" : ""}
                onClick={() => {
                  toggleTab(3);
                }}
              >
                Activities
              </NavLink>
            </NavItem>
            
            <NavItem>
              <NavLink
                className={activeTab === 4 ? "active" : ""}
                onClick={() => {
                  toggleTab(4);
                }}
              >
                F&Q's
              </NavLink>
            </NavItem>
          </Nav>

        <section className="form-section">

            <TabContent activeTab={activeTab}>
              
              
              
              
            
          <TabPane tabId={1}>
          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Featured</Label>
              <Field
                name="featured"
                component={Switch}
                type="text"
              />
            </FormGroup>
            {featured &&
              <FormGroup className="col-12 col-sm-6">
                <Label htmlFor="email">Order</Label>
                <Field
                  name="order"
                  component={TextInput}
                   defaultValue={order && order || ''}
                  type="number"
                />
              </FormGroup>
            }
          </div>
          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Name</Label>
              <Field
                name="name"
                component={TextInput}
                placeholder="Deal Type Name"
                defaultValue={name && name || ''}
                type="text"
                validate={validations.required}
                autoFocus={true}
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">URL</Label>
              <Field
                name="slug"
                component={TextInput}
                 defaultValue={slug && slug || ''}
                placeholder="url"
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div>

          {/* <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Title</Label>
              <Field
                name="title"
                component={Wysiwyg}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div> */}
          <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Description</Label>
              <Field
                name="description"
                component={Wysiwyg}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div>
          <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Summary</Label>
              <Field
                name="summary"
                component={Wysiwyg}
                type="text"

              />
            </FormGroup>
          </div>
          <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Page Description</Label>
              <Field
                name="page_description"
                component={Wysiwyg}
                type="text"

              />
            </FormGroup>
          </div>

          {/* 
          <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Summary</Label>
              <Field
                name="summary"
                component={Wysiwyg}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div> */}

          <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Banner Image</Label>
              <Field
                name="banner_image"
                component={FileUpload}
                multiple={false}
                files={false}
                images={true}
                type="text"
                className="form-control"
                validate={validations.required}
              />
            </FormGroup>
          </div>
          </TabPane>
          <TabPane tabId={2}>
                <ReviewsTable
                  data={props.reviews}
                  dispatch={props.dispatch}
                  formValues={props.formValues}
                  initialValues={props.initialValues}
                  formType='DealTypeForm'
                />
              </TabPane>
              <TabPane tabId={3}>
                <FieldArray name={"activities"} component={Activites} />
              </TabPane>
              <TabPane tabId={4}>
                <FieldArray name={"faqs"} component={Faq} />
              </TabPane>
          </TabContent>
        </section>
        
      </Form>
      

      {props.submitFailed && (
        <div className="error-container">
          <Alert color="danger">
            <strong>There are errors in your form.</strong>
            <br />Please check before submitting again.
          </Alert>
        </div>
      )}
    </section>
  );
};

EditForm = reduxForm({
  form: "DealTypeForm",
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) { dispatch(stopSubmit("DealTypeForm")) }
  }
})(EditForm);

const selector = formValueSelector('DealTypeForm');

const mapStateToProps = state => ({
  featured: selector(state, 'featured')
});

export default connect(mapStateToProps)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/DealTypes/Form.jsx